@if (menu) {
<div class="link-nav">
  @for (menuItem of menu; track menuItem) {
  <div [ngClass]="menuItem.children ? 'header-menu-dropdown' : ''" class="-link-items">
    @if (!menuItem.children && !menuItem.external && !menuItem.hidedesktop) {
    <a
      [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
      [routerLink]="'/' + menuItem.path"
      aria-label="MainNav">
      {{ menuItem.title }}
    </a>
    } @if (!menuItem.children && menuItem.external) {
    <a
      [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
      href="{{ menuItem.path }}"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="MainNav">
      {{ menuItem.title }}
    </a>
    } @if (menuItem.children) {
    <app-link (click)="openParentMenu($event)"
      ><span>{{ menuItem.title }}</span>
      <lucide-icon name="chevron-down" class="-custom-size-icon -desktop-icon"></lucide-icon>
      <span class="-icon-container">
        <lucide-icon name="chevron-right" class="-custom-size-icon -responsive-icon"></lucide-icon>
      </span>
    </app-link>
    } @if (menuItem.children) {
    <header-nav-dropdown
      class="-menu"
      [title]="menuItem.title"
      [menuContent]="menuItem"
      [type]="menuItem.template ? menuItem.template : 'Solutions'"
      (closeNavEvent)="closeParentMenu($event)">
    </header-nav-dropdown>
    }
  </div>
  }
</div>
}
